import styled from "styled-components";
import FancyImage from "./FancyImage";

const Hero = styled(FancyImage)``;

export default Hero;
